import { ExtractionDocumentType } from './StartDocumentExtraction';

/**
 * Raw extraction status values. PROCESSING and EXTRACTED are owned by HADES, the rest by HRPS.
 * The service models status as an open String, so callers must tolerate unknown values.
 */
export const ExtractionStatus = {
    PROCESSING: 'PROCESSING',
    EXTRACTED: 'EXTRACTED',
    DRAFT: 'DRAFT',
    CREATED: 'CREATED',
    TRANSACTION_SUBMITTED: 'TRANSACTION_SUBMITTED',
    FAILED: 'FAILED',
    DISCARDED: 'DISCARDED',
} as const;

/** The five states a reseller sees on the extraction dashboard. */
export type ExtractionDisplayStatus = 'PROCESSING' | 'DRAFT' | 'CREATED' | 'FAILED' | 'DISCARDED';

export type ExtractionSortAttribute =
    | 'CREATED_AT'
    | 'UPDATED_AT'
    | 'STATUS'
    | 'CUSTOMER_REFERENCE'
    | 'DOCUMENT_TYPE'
    | 'FILE_NAME'
    | 'SOURCE'
    | 'REQUESTED_BY';

export type ExtractionSortOrder = 'ASCENDING' | 'DESCENDING';

export interface ExtractionSummary {
    extractionId: string;
    status: string;
    createdAt: number;
    documentType?: ExtractionDocumentType;
    documentSubType?: string;
    customerReference?: string;
    fileName?: string;
    requestedBy?: string;
    source?: string;
    errorCode?: string;
    transactionId?: string;
    hdssSourceDocId?: string;
    hdssResultDocId?: string;
    updatedAt?: number;
}

export interface ExtractionFilters {
    extractionIds?: string[];
    statuses?: string[];
    documentType?: ExtractionDocumentType;
    documentSubType?: string;
    source?: string;
    errorCode?: string;
    transactionId?: string;
    customerReference?: string;
    fileName?: string;
    requestedBy?: string;
    createdAfter?: number;
    createdBefore?: number;
}

export interface ListDocumentExtractionsInput {
    resellerId: string;
    maxResults: number;
    startAtResult: number;
    filters?: ExtractionFilters;
    sortBy?: ExtractionSortAttribute;
    sortOrder?: ExtractionSortOrder;
}

export interface ListDocumentExtractionsOutput {
    extractions: ExtractionSummary[];
    totalResults: number;
}
